<template>
  <v-container id="dashboard" fluid tag="section">
    <v-row>
      <v-col cols="12" md="6" class="green lighten-4">
        <h3 class="text-center">ALERTAS</h3>
        <v-data-table
          :headers="headersAlertas"
          :items="alertasList"
          :loading="loading"
          :items-per-page="5"
          sort-by="fecha"
          sort-desc
          no-data-text="Todo ok. Respira Ranea"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="ticketsSinImprimir.length > 0"
        class="red lighten-4"
      >
        <h3 class="text-center">TICKETS SIN IMPRIMIR</h3>
        <v-data-table
          :items="ticketsSinImprimir"
          sort-by="fecha"
          :sort-desc="true"
          :items-per-page="5"
          :headers="headersTickets"
          no-data-text="Todo ok. Respira Ranea"
        >
          <template v-slot:item.acciones="{ item }">
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1 black--text"
                  color="warning lighten-3"
                  min-width="0"
                  v-on="on"
                  :loading="item.loading"
                  small
                  @click="comprobarImpresion(item)"
                >
                  <v-icon small>mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span
                >{{ item.impresionObligatoria }} Comprobar vía servidor</span
              >
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="teal lighten-3"
                  min-width="0"
                  v-on="on"
                  :loading="item.loading"
                  small
                  @click="marcarImpreso(item)"
                >
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Marcar como impreso</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="pedidosEliminar.length > 0"
        class="yellow lighten-4"
      >
        <h3 class="text-center">PEDIDOS SOLICITADO ELIMINACIÓN</h3>
        <v-data-table
          :items="pedidosEliminar"
          sort-by="numPedido"
          :sort-desc="true"
          :items-per-page="5"
          :headers="headersTicketsEliminar"
          no-data-text="Todo ok. Respira Ranea"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="blue lighten-4"
        v-if="pedidosPendientePago.length > 0"
      >
        <h3 class="text-center">PEDIDOS PENDIENTE PAGO</h3>
        <v-data-table
          :items="pedidosPendientePago"
          sort-by="fecha"
          :sort-desc="true"
          :items-per-page="5"
          :headers="headersTickets"
          no-data-text="Todo ok. Respira Ranea"
        >
          <template v-slot:item.acciones="{ item }">
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="info darken-1"
                  min-width="0"
                  v-on="on"
                  :loading="item.loading"
                  small
                  @click="comprobarPedidoPendientePago(item)"
                >
                  <v-icon small>mdi-currency-eur</v-icon>
                </v-btn>
              </template>
              <span>Comprobar pago</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12">
        <v-row justify="center" align="center">
          <h3 class="text-center">RESTAURANTES CON PROBLEMAS</h3>
          <v-checkbox class="ml-3" v-model="showOcultos" label="ocultos" />
        </v-row>
        <v-data-table
          :items="restaurantesTodos"
          sort-by="fecha"
          :sort-desc="true"
          :items-per-page="5"
          :headers="headersRestaurante"
          no-data-text="Todo ok. Respira Ranea"
        >
          <template v-slot:item.id="{ item }">
            <v-row>
              <v-col cols="5">
                <v-row no-gutters>
                  <v-tooltip
                    top
                    v-if="
                      !dashboardConfig.ocultarRestaurantes.includes(item.id)
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        text
                        @click="ocultarRestaurante(item)"
                        v-on="on"
                        small
                        style="text-decoration: none !important"
                        :loading="loadingOcultar"
                      >
                        <v-icon color="success">mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Ocultar este restaurante</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="dashboardConfig.ocultarRestaurantes.includes(item.id)"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        text
                        @click="mostrarRestaurante(item)"
                        v-on="on"
                        small
                        style="text-decoration: none !important"
                        :loading="loadingOcultar"
                      >
                        <v-icon color="red">mdi-eye-off</v-icon>
                      </v-btn>
                    </template>
                    <span>Mostrar este restaurante</span>
                  </v-tooltip>
                  <v-btn
                    class="pa-0 ma-0"
                    text
                    small
                    :href="`tel:${item.telefono}`"
                    style="text-decoration: none !important"
                  >
                    <v-icon class="ma-0">mdi-phone</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
              <v-col cols="7"
                >{{ idToTexto(item.negocio) }} {{ item.nombre }}</v-col
              >
            </v-row>
          </template>
          <template v-slot:item.estado="{ item }">
            <v-chip
              v-if="loadingComprobar"
              class="ma-2"
              color="info"
              text-color="white"
              >Comprobando</v-chip
            >
            <v-chip
              v-if="item.estado == 'conectado' && !loadingComprobar"
              class="ma-2"
              color="green"
              text-color="white"
              @click="comprobarConexion(item)"
              >Online</v-chip
            >
            <v-chip
              v-else-if="!loadingComprobar"
              @click="comprobarConexion(item)"
              class="ma-2"
              color="red"
              text-color="white"
              >Offline</v-chip
            >
            <v-chip
              v-if="item.horariosComputados && item.horariosComputados[0]"
              class="ma-2"
              color="green"
              text-color="white"
              >Domicilio</v-chip
            >
            <v-chip v-else class="ma-2" color="red" text-color="white"
              >Domicilio</v-chip
            >
            <v-chip
              v-if="item.horariosComputados && item.horariosComputados[1]"
              class="ma-2"
              color="green"
              text-color="white"
              >Recoger</v-chip
            >
            <v-chip v-else class="ma-2" color="red" text-color="white"
              >Recoger</v-chip
            >
            <v-chip
              v-if="item.horariosComputados && item.horariosComputados[2]"
              class="ma-2"
              color="green"
              text-color="white"
              >Apertura</v-chip
            >
            <v-chip v-else class="ma-2" color="red" text-color="white"
              >Apertura</v-chip
            >
          </template>
          <template v-slot:item.modoHorarioDomicilio="{ item }">
            <v-select
              :loading="loadingHorario"
              @change="cambioModo(item)"
              :items="modoHorarios"
              v-model="item.modoHorarioDomicilio"
              label="¿Forzado Domicilio?"
            />
          </template>
          <template v-slot:item.modoHorarioRecoger="{ item }">
            <v-select
              @change="cambioModo(item)"
              :loading="loadingHorario"
              :items="modoHorarios"
              v-model="item.modoHorarioRecoger"
              label="¿Forzado Recoger?"
            />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-divider />
    <v-row justify="center" align="center">
      <v-col cols="12" sm="6" md="3">
        <v-select
          v-model="filtrosEleccion.negocio"
          :items="$store.state.app.negociosGestArray"
          multiple
          @change="reiniciarNegocio"
          label="Negocio"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select
          v-if="isAdmin || isBossNegocio"
          item-value="id"
          item-text="nombre"
          v-model="filtrosEleccion.restaurantes"
          multiple
          :items="restaurantesFiltrados"
          label="Restaurante"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-select
          v-model="filtrosEleccion.formaPago"
          multiple
          :items="$store.state.estadisticas.filtros.formaPago"
          label="Forma Pago"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-select
          v-model="filtrosEleccion.modo"
          multiple
          :items="$store.state.estadisticas.filtros.modo"
          label="Modo"
        />
      </v-col>
      <!--<v-col cols="12" sm="6" md="1">
        <v-btn class="primary" small>
          <v-icon>mdi-backup-restore</v-icon>
        </v-btn>
      </v-col>-->
      <v-col cols="12" sm="6" md="1">
        <!--<v-btn class="secondary" small>
          <v-icon>mdi-backup-restore</v-icon>
        </v-btn>-->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <base-material-stats-card
          color="info"
          icon="mdi-shopping"
          title="Pedidos"
          :value="numPedidosGlobales"
          sub-icon="mdi-clock"
          sub-text="En el día de hoy"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <base-material-stats-card
          color="primary"
          icon="mdi-poll"
          title="Facturado"
          :value="total"
          sub-icon="mdi-clock"
          sub-text="En el día de hoy"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <base-material-stats-card
          color="success"
          icon="mdi-store"
          title="Ganancias"
          :value="ganancias"
          sub-icon="mdi-calendar"
          sub-text="Apróximadas"
        />
      </v-col>
    </v-row>
    <v-divider />
    <v-row>
      <v-col cols="12" md="6">
        <v-data-table
          :headers="headers"
          :items="pedidosAgrupados.rest"
          :loading="loading"
          :must-sort="true"
          sort-by="numPedidos"
          :sort-desc="true"
        >
          <template v-slot:item.id="{ item }">{{
            idToTexto(item.id)
          }}</template>
          <template v-slot:item.total="{ item }"
            >{{ item.total.toFixed(2) }} €</template
          >
        </v-data-table>
      </v-col>
      <v-col cols="12" md="6">
        <v-data-table
          :headers="headers"
          :items="pedidosAgrupados.negocio"
          :loading="loading"
          :must-sort="true"
          sort-by="numPedidos"
          :sort-desc="true"
        >
          <template v-slot:item.id="{ item }">{{
            idToTexto(item.id)
          }}</template>
          <template v-slot:item.total="{ item }"
            >{{ item.total.toFixed(2) }} €</template
          >
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { idToTexto } from "@/utils/utils.js";

export default {
  name: "DashboardDashboard",

  data() {
    return {
      showOcultos: false,
      valorSegundos: null,
      loading: false,
      filtrosEleccion: {
        formaPago: [],
        showEliminados: false,
        negocio: [],
        restaurantes: [],
        modo: [],
      },
      tipoFiltro: [1, 2],
      loadingComprobar: false,
      headersRestaurante: [
        {
          sortable: false,
          text: "#",
          value: "id",
          width: "35%",
        },
        {
          sortable: false,
          text: "Estado",
          value: "estado",
          width: "35%",
          align: "center",
        },
        {
          sortable: false,
          text: "Modo Domicilio",
          value: "modoHorarioDomicilio",
          width: "15%",
        },
        {
          sortable: false,
          text: "Modo Recoger",
          value: "modoHorarioRecoger",
          width: "15%",
        },
      ],
      headersAlertas: [
        {
          sortable: false,
          text: "Prioridad",
          value: "prioridad",
        },
        /*{
          sortable: false,
          text: "Tipo",
          value: "tipo",
        },*/
        {
          sortable: false,
          text: "Última Fecha",
          value: "lastFecha",
        },
        {
          sortable: false,
          text: "Último Mensaje",
          value: "lastMensaje",
        },
      ],
      headersTickets: [
        {
          sortable: false,
          text: "#",
          value: "id",
        },
        {
          sortable: false,
          text: "Hora",
          value: "fecha",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
        },
      ],
      headersTicketsEliminar: [
        {
          sortable: false,
          text: "#",
          value: "id",
        },
        {
          sortable: false,
          text: "Hora",
          value: "fecha",
        },
      ],
      headers: [
        {
          sortable: false,
          text: "#",
          value: "id",
        },
        {
          sortable: false,
          text: "Pedidos",
          value: "numPedidos",
        },
        {
          sortable: false,
          text: "Total",
          value: "total",
        },
      ],
      snapRealTime: null,
      loadingOcultar: false,
      loadingHorario: false,
    };
  },

  computed: {
    pedidosPendientePago() {
      return this.$store.state.pedidos.pedidosPendienteConfirmacionPago.map(
        (p) => {
          return {
            ...p,
            fecha: moment(p.fechaServidor.toDate()).format("HH:mm"),
          };
        }
      );
    },
    alertasList() {
      return this.alertasListGetters
        .sort((a, b) => {
          if (a.lastMensaje.includes("cierre")) {
            return -1;
          } else if (b.lastMensaje.includes("cierre")) {
            return 1;
          } else {
            return b.lastFechaUnix - a.lastFechaUnix;
          }
        })
        .filter((a) => {
          return this.tipoFiltro.includes(a.prioridad);
        });
    },
    ...mapState({
      modoHorarios: (state) => state.negocios.modoHorarios,
      restaurantesTodosBruto: (state) =>
        state.restaurantes.restaurantesTodosArray,
      dashboardConfig: (state) => state.app.dashboardConfig,
      pedidosEliminarBruto: (state) => state.pedidos.pedidosEliminar,
    }),
    ...mapGetters({
      negocioGestSlug: "app/negocioGestObj",
      alertasListGetters: "alertas/getAlertasList",

      //numPedidosGlobales: "pedidos/numeroPedidos",
      numAlertas: "alertas/getAlertasCount",
      pedidosBruto: "pedidos/getPedidosListado",
      role: "auth/role",
    }),
    restaurantesTodos() {
      return this.restaurantesTodosBruto.filter((r) => {
        return (
          (this.showOcultos ||
            (this.dashboardConfig &&
              !this.dashboardConfig.ocultarRestaurantes.includes(r.id))) &&
          (r.modoHorarioDomicilio == "forzado_cierre" ||
            r.modoHorarioDomicilio == "forzado_cierre_sistema" ||
            r.modoHorarioRecoger == "forzado_cierre" ||
            r.modoHorarioRecoger == "forzado_cierre_sistema" ||
            (r.horaConectado == null &&
              r.horariosComputados &&
              r.horariosComputados[0]) ||
            (r.horaConectado == null &&
              r.horariosComputados &&
              r.horariosComputados[1]))
        );
      });
    },
    ticketsSinImprimir() {
      return this.pedidosBruto.filter((p) => {
        let noImpreso =
          p.printNodeEstado != "imprimido" &&
          p.impresionLocalEstado != "impreso";
        return noImpreso && p.fechaServidor.seconds + 60 < this.valorSegundos;
      });
    },
    pedidosEliminar() {
      return this.pedidosEliminarBruto;
    },
    pedidos() {
      return this.pedidosBruto.filter((p) => {
        console.log(p);
        return (
          !p.eliminado &&
          !p.multiple &&
          (this.filtrosEleccion.negocio.length == 0 ||
            this.filtrosEleccion.negocio.includes(p.negocio)) &&
          (this.filtrosEleccion.restaurantes.length == 0 ||
            this.filtrosEleccion.restaurantes.includes(
              p.negocio + "-" + p.restaurante
            )) &&
          (this.filtrosEleccion.formaPago.length == 0 ||
            this.filtrosEleccion.formaPago.includes(p.forma_pago)) &&
          (this.filtrosEleccion.modo.length == 0 ||
            this.filtrosEleccion.modo.includes(p.modo))
        );
      });
    },
    numPedidosGlobales() {
      return this.pedidos.filter((p) => !p.multiple).length.toString();
    },
    total() {
      return this.totalFloat.toFixed(2) + " €";
    },
    totalFloat() {
      return this.pedidos
        .filter((p) => !p.multiple)
        .reduce(
          (acc, val) =>
            acc + parseFloat(val.precioTotal > 0 ? val.precioTotal : 0),
          0
        );
    },
    isAdmin() {
      return this.role == "admin";
    },
    isBossNegocio() {
      return this.role == "boss_negocio";
    },
    ganancias() {
      return (this.totalFloat * 0.08).toFixed(2) + " €";
    },
    pedidosAgrupados() {
      var agrupadosRest = [];
      var agrupadosNegocio = [];
      this.pedidos.map((p, i) => {
        var foundIndex = agrupadosRest.findIndex(
          (r) => p.negocio + "-" + p.restaurante == r.id
        );
        if (foundIndex >= 0) {
          agrupadosRest[foundIndex].numPedidos =
            agrupadosRest[foundIndex].numPedidos + 1;
          agrupadosRest[foundIndex].total =
            agrupadosRest[foundIndex].total + parseFloat(p.precioTotal);
        } else {
          agrupadosRest.push({
            id: p.negocio + "-" + p.restaurante,
            negocio: p.negocio,
            numPedidos: 1,
            total: parseFloat(p.precioTotal),
          });
        }
        //ahora en negocio
        var foundIndex = agrupadosNegocio.findIndex((r) => p.negocio == r.id);
        if (foundIndex >= 0) {
          agrupadosNegocio[foundIndex].numPedidos =
            agrupadosNegocio[foundIndex].numPedidos + 1;
          agrupadosNegocio[foundIndex].total =
            agrupadosNegocio[foundIndex].total + parseFloat(p.precioTotal);
        } else {
          agrupadosNegocio.push({
            id: p.negocio,
            negocio: p.negocio,
            numPedidos: 1,
            total: parseFloat(p.precioTotal),
          });
        }
      });
      return { rest: agrupadosRest, negocio: agrupadosNegocio };
    },
    restaurantesFiltrados() {
      var rest;
      if (this.isBossNegocio) {
        rest = this.$store.state.restaurantes.restaurantesArray;
      } else if (this.isAdmin) {
        rest = this.$store.state.app.restaurantesArray;
      }
      var res = rest.filter((e) =>
        this.filtrosEleccion.negocio.includes(e.negocio)
      );
      return res;
    },
  },

  methods: {
    comprobarPedidoPendientePago(item) {
      // item.loading = true;
      this.$store
        .dispatch("pedidos/comprobarPedidoPendientePago", item)
        .then((r) => {
          console.log(r);
          if (r.data.ok) {
            if (r.data.pagado) {
              this.$store.commit("snackbar/setMensajeSuccess", {
                msj: "El pedido está pagado. Se ha generado",
              });
            } else {
              this.$store.commit("snackbar/setMensajeSuccess", {
                msj: "El pedido no está pagado.",
              });
            }
          }
        })
        .finally(() => (item.loading = false));
    },
    marcarImpreso(item) {
      item.loading = true;
      this.$store
        .dispatch("pedidos/marcarImpreso", item)
        .finally(() => (item.loading = false));
    },
    comprobarImpresion(item) {
      item.loading = true;
      this.$store
        .dispatch("pedidos/comprobarImpreso", item)
        .finally(() => (item.loading = false));
    },
    idToTexto(s) {
      return idToTexto(s);
    },
    comprobarConexion(item) {
      let _vm = this;
      _vm.loadingComprobar = true;
      console.log(item);
      this.$store
        .dispatch("restaurantes/comprobarConexion", item)
        .finally(() => (_vm.loadingComprobar = false));
    },
    cambioModo(item) {
      var _vm = this;
      _vm.loadingHorario = true;
      this.$store
        .dispatch("restaurantes/saveDatos", {
          modoHorarioDomicilio: item.modoHorarioDomicilio,
          modoHorarioRecoger: item.modoHorarioRecoger,
          id: item.id,
        })
        .then((r) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Horario cambiado",
          });
        })
        .catch((e) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al cambiar el horario " + e,
          });
        })
        .finally(() => (_vm.loadingHorario = false));
    },
    ocultarRestaurante(item) {
      let _vm = this;
      _vm.loadingOcultar = true;
      this.$store
        .dispatch("app/saveOcultarRestauranteDashboard", item.id)
        .then((r) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Restaurante oculto",
          });
        })
        .then(() => {
          return this.$store.dispatch("app/getConfiguracionDashboard");
        })
        .catch((e) => {
          if (e != "cancelar") {
            this.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al ocultar el restaurante " + e,
            });
          }
        })
        .finally(() => (_vm.loadingOcultar = false));
    },
    mostrarRestaurante(item) {
      let _vm = this;
      _vm.loadingOcultar = true;
      this.$store
        .dispatch("app/saveMostrarrRestauranteDashboard", item.id)
        .then((r) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Restaurante mostrado",
          });
        })
        .then(() => {
          return this.$store.dispatch("app/getConfiguracionDashboard");
        })
        .catch((e) => {
          if (e != "cancelar") {
            this.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al mostrar el restaurante " + e,
            });
          }
        })
        .finally(() => (_vm.loadingOcultar = false));
    },
    actualizarTiempo() {
      var _vm = this;
      _vm.valorSegundos = moment().unix();
      setInterval(() => {
        _vm.valorSegundos = moment().unix();
      }, 10000);
    },
    complete(index) {
      this.list[index] = !this.list[index];
    },
    goAlerta() {
      this.router.push("/admin/alertas");
    },
    reiniciarNegocio() {
      this.filtrosEleccion.restaurantes = [];
    },
  },
  mounted() {
    this.actualizarTiempo();
    var _vm = this;
    this.$store
      .dispatch("restaurantes/getTodosRestaurantes")
      .then((r) => (_vm.snapRealTime = r));
  },
  beforeDestroy() {
    this.snapRealTime();
  },
};
</script>
<style scoped>
.google-data-studio {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 100%;
  overflow: hidden;
}

.google-data-studio iframe,
.google-data-studio object,
.google-data-studio embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>